













































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Space from "@/components/mobile/Space.vue";

export default Vue.extend({
  name: "CommonFooter",
  data() {
    return {
      isShowMenu: true,
      menuList: [
        {
          title: "Services",
          showMenu: false,
          list: [
            {
              title: "Legend OTC",
              href: "/legend-otc"
            },
            {
              title: "Legend Pay",
              href: "/legend-pay"
            },
            {
              title: "Showcases",
              href: "/cases"
            },
            {
              title: "Trade with us",
              href: "/kyc"
            }
          ]
        },
        {
          title: "Showcases",
          showMenu: false,
          list: [
            {
              title: "KuCoin",
              href: "/cases/kucoin"
            },
            {
              title: "Gate.io",
              href: "/cases/gateio"
            },
            {
              title: "Phemex",
              href: "/cases/phemex"
            },
            {
              title: "View all",
              href: "/cases"
            }
          ]
        },
        {
          title: "Developers",
          showMenu: false,
          list: [
            {
              title: "Guidelines & Code",
              href: "/developers"
            }
          ]
        },
        {
          title: "Company",
          showMenu: false,
          list: [
            {
              title: "About us",
              href: "/about"
            },
            {
              title: "Become our partner",
              href: "/partner"
            },
            {
              title: "Support help center",
              href: "https://support.legendtrading.com/hc/en-us"
            },
            {
              title: "Blog",
              href:
                "https://support.legendtrading.com/hc/en-us/sections/1260801558890-Announcements"
            }
          ]
        },
        {
          title: "Follow",
          showMenu: false,
          list: [
            {
              title: "Twitter",
              href: "https://twitter.com/LegendOTC"
            },
            {
              title: "LinkedIn",
              href: "https://www.linkedin.com/company/legend-trading"
            },
            {
              title: "Contact us",
              href: ""
            }
          ]
        }
      ],
      headerClass: {
        dark: "dark-header",
        light: "light-header",
        transparent: ""
      }
    };
  },
  computed: {
    ...mapState({
      open: (state: any) => state.isZendeskOpened
    })
  },
  methods: {
    ...mapActions(["toggleZendesk"]),
    navigateTo(herf: string) {
      window.open(herf);
    },
    onTouched() {
      this.toggleZendesk(!this.open);
    }
  },
  components: {
    MobileSpace: Space
  }
});
